"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface LeaseLiabilityClassicTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "lease-as-1",
    question: "Does the entity have finance lease arrangements (AS 19)?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "lease-as-2",
    question: "Does the entity have operating lease arrangements?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "lease-as-3",
    question: "Are there any related party lease transactions in the current period?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function LeaseLiabilityClassicTailoringQuestions({ onBack }: LeaseLiabilityClassicTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Lease Liability"
      title="Lease Liability - Tailoring Questions"
      description="Customize the audit program for Lease Liability"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
